module.exports = __webpack_public_path__ + "static/media/autoCADAddons5.02453db3.png";